function loadPostHog() {
  // prettier-ignore
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Mi Ri init Vi Gi Rr Wi Ji Bi capture calculateEventProperties tn register register_once register_for_session unregister unregister_for_session an getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync un identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty nn Xi createPersonProfile setInternalOrTestUser sn Hi cn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ki debug Lr rn getPageViewId captureTraceFeedback captureTraceMetric Di".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  // prettier-ignore
  posthog.init('phc_7CgLoetviGa7GLXDemc16kZquIASNBqxoPemzhJSqkb', {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2026-01-30',
        capture_performance: true,
    session_idle_timeout_seconds: 14400, // 4 ore invece di 30 min
    //person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
});

  posthog.register({
    theme_name: Shopify.theme.name,
  });

  posthog.onFeatureFlags(function (flags, flagVariants, { errorsLoading }) {
    const PREFIX = "ph_flag_";
    function setCookie(name, value) {
      var date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie =
        name +
        "=" +
        value +
        "; expires=" +
        date.toUTCString() +
        "; path=/; SameSite=Lax";
    }
    for (const [key, flag] of Object.entries(flags)) {
      const enabled = posthog.getFeatureFlag(flag) == "test";
      // save cookie
      setCookie(PREFIX + flag, enabled ? "true" : "false");

      if (enabled) {
        // update DOM
        document.documentElement.classList.add(flag);
      }
    }
  });
}

document.addEventListener("visitorConsentCollected", (event) => {
  if (event.detail.analyticsAllowed) {
    if (!window.posthog) {
      loadPostHog();
    }
  }
});

window.Shopify?.loadFeatures?.(
  [{ name: "consent-tracking-api", version: "0.1" }],
  (error) => {
    if (error) {
      return;
    }
    if (
      window.Shopify?.customerPrivacy &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    ) {
      if (!window.posthog) {
        loadPostHog();
      }
    }
  },
);
